import { useQuery } from "@tanstack/react-query";
import { getModels } from "../../api/models";

export const MODELS_QUERY_KEY = ["models"] as const;

export function useModels() {
  return useQuery({
    queryKey: MODELS_QUERY_KEY,
    queryFn: getModels,
    staleTime: 30_000,
  });
}
